<template>
  <el-container class="admin-layout admin-scope-reset">
    <el-aside width="240px" class="admin-aside">
      <div class="admin-brand">
        <span>PPT 运营管理</span>
        <el-button type="text" class="admin-logout" @click="logout">
          退出
        </el-button>
      </div>
      <el-menu
        :default-active="activePath"
        router
        class="admin-menu"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
      >
        <el-menu-item
          v-for="item in menuItems"
          :key="item.path"
          :index="'/admin/' + item.code"
        >
          {{ item.title }}
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-main class="admin-main">
      <router-view />
    </el-main>
  </el-container>
</template>

<script>
import { PPT_MODULES, PPT_MODULE_CODES } from "@/constants/pptModules";

export default {
  name: "AdminLayout",
  computed: {
    menuItems() {
      return PPT_MODULE_CODES.map(code => ({
        code,
        title: PPT_MODULES[code].title,
        path: `/admin/${code}`
      }));
    },
    activePath() {
      return this.$route.path;
    }
  },
  methods: {
    logout() {
      this.$cookies.remove("token", { path: "/" });
      this.$router.replace({
        path: "/admin/login",
        query: { redirect: this.$route.fullPath }
      });
    }
  }
};
</script>

<style lang="less" scoped>
/* 覆盖全局 public.css 中 body 的白字，保证后台可读 */
.admin-scope-reset {
  color: #303133;
  -webkit-font-smoothing: antialiased;
  user-select: text;
}
.admin-scope-reset ::v-deep(.el-button),
.admin-scope-reset ::v-deep(.el-table),
.admin-scope-reset ::v-deep(.el-table th),
.admin-scope-reset ::v-deep(.el-table td) {
  user-select: text;
}

.admin-layout.el-container {
  min-height: 100vh;
}

.admin-aside {
  background: #304156;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.admin-brand {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 20px 16px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.03em;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.admin-logout {
  flex-shrink: 0;
  padding: 0;
  font-size: 13px;
  color: #bfcbd9 !important;
}
.admin-logout:hover {
  color: #409eff !important;
}

.admin-menu {
  border-right: none !important;
}

.admin-menu.el-menu ::v-deep(.el-menu-item) {
  height: 48px;
  line-height: 48px;
}

.admin-main {
  padding: 24px 28px 40px !important;
  background: #f0f2f5;
  overflow-x: auto;
}
</style>
